import React, { Component } from "react";
import api_fetch from "../../../api.js"


class ActionButton extends Component {
    constructor() {
        super();
        this.execute = this.execute.bind(this);
    }
    execute() {
        this.props.executor(this.props.action);
    }
    render() {
        let className = "button-container button-action "
        let button = null;
        if (!this.props.enabled){
            className += "button-disabled"
            button = <button className={className} >{this.props.action}</button>
        }
        else{
            button = <button className={className} onClick={this.execute}>{this.props.action}</button>
        }
        return button
        
    }
}
class ActuatorPad extends Component {
    constructor() {
        super();
        this.fetchActuatorState = this.fetchActuatorState.bind(this);
        this.actionExecutor = this.actionExecutor.bind(this);
        this.state = {
            actuator_state: {response_code:0, actions: []},
            fetching: null,
            enabled: false,
        }
    }
    fetchActuatorState() {
        this.setState({fetching: "getting-state", enabled: false});
        api_fetch(`/api/actuator/${this.props.actuator.name}`).then(response => {
            if (!response.ok){
              throw new Error(`${response.status}: ${response.statusText}`)
            }
            return response.json();
        })
        .then(actuator_state => {
            let enabled = false;
  
            if (actuator_state.response_code == 200){
                enabled = true;
            }
            actuator_state.response_message = JSON.parse(actuator_state.response_message)
            this.setState({actuator_state, enabled, fetching: "getting-state-done"})
        })
        .catch(error => {
            this.setState({fetching: "error-getting-state"});
        });
    }
    actionExecutor(action){
        this.setState({fetching: "executing-action", enabled: false});

        api_fetch(
            `/api/actuator/${this.props.actuator.name}`,
            {
                method: 'POST',
                body: `${action}`
            }
        ).then(response => {
            if (!response.ok){
              throw new Error(`${response.status}: ${response.statusText}`)
            }
            return response.json();
        })
        .then(actuator_state => {
            // let enabled = false;
            if (actuator_state.requires_cams && actuator_state.requires_cams.length == 1){
                if(actuator_state.requires_cams[0].length == 0)
                {
                delete actuator_state.requires_cams;
              }
            }
    
            if (actuator_state.response_code == 200){
                // enabled = true;
                this.setState({fetching: "action-executed", enabled: false});
            }
        //   this.setState({actuator_state, enabled, fetching: "getting-state-done"})
            this.fetchActuatorState();
        })
        .catch(error => {
            this.setState({fetching: "error-getting-state"});
        });
    }

    componentDidMount(){
        this.fetchActuatorState();
    }
    

    render(){
        let state = undefined;
        // debugger;
        if (this.state.actuator_state.response_message !== undefined){
            let value = this.state.actuator_state.response_message.value;
            if(value !== undefined){
                if(value === true){
                    state = <div className="actuator-value">ON</div>
                }
                else if(value === false){
                    state = <div className="actuator-value">OFF</div>
                }
            }
        }
        let actions = this.state.actuator_state.actions.map(action => {
            let video_requirement_ok = true;
            if(this.state.actuator_state.requires_cams){
                for(let cam of this.state.actuator_state.requires_cams.map(camName => camName.split(".").slice(0,-1).join("."))){
                    if (cam.length == 0){
                        continue
                    }
                    if(! cam in this.props.videoStatus ){
                        video_requirement_ok = false;
                        // console.log("cam not in videoStatus", cam);
                        break
                    }
                    if(! this.props.videoStatus[cam]){
                        // console.log("cam status false", cam);
                        video_requirement_ok = false;
                        break
                    }
                }
            }
            let buttonClass = ""
            let enabled = true;
            if(! this.state.enabled || !video_requirement_ok){
                enabled = false;
                buttonClass = "btn-disabled"
                console.log("actuator actions disabled. video_requirement_ok", video_requirement_ok)
            }
            return (
                <ActionButton 
                    enabled={enabled}
                    action={action}
                    key={`${this.state.actuator_state.name}`+`${action}`}
                    executor={this.actionExecutor}
                />
            );
        });
        let actuatorPad = (
            <div className="flex-row"> 
                {/* <div>name: {this.props.actuator.name} </div> */}

                {state}
                <div>{actions}</div>
                <div>
                    <button className="button-container button-close button-actuator-close" onClick={this.props.closeActuatorPad}>
                    &#9746;
                    </button>
                </div>
                {/* <div>fetching: {this.state.fetching} </div> */}
                {/* <div> {this.state.actuator_state.response_code} </div> */}
            </div>
        );

        
        return actuatorPad;
    }
}



export default ActuatorPad;